<template>
    <div class="tabs-inspections panel panel-default">
        <div class="list-inspections" data-infinite-scroll>
            <panel-search @search="search" placeholder="Введите ГОС или VIN номер, или название автомобиля для поиска"
                          class="panel-search-light"></panel-search>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Автомобиль</th>
                    <th>Гос. номер</th>
                    <th>VIN номер</th>
                    <th>Заполнено</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="inspection in inspections">
                    <td>
                        <a :href="`/inspections/${inspection.id}`">{{ inspection.brand.name }} {{ inspection.model.name }}</a>
                    </td>
                    <td>{{ inspection.state_number }}</td>
                    <td>{{ inspection.vin_number }}</td>
                    <td>{{ inspection.completed_at | date_format('DD.MM.YYYY HH:mm') }}</td>
                </tr>
                </tbody>
            </table>

            <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        props: [
            'user_id'
        ],
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            inspections() {
                return axios
                    .get('/api/inspections', {
                        params: {
                            user_id: this.user_id,
                            q: this.q,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.inspections.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.inspections = this.inspections.concat(data.inspections.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (!infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if (this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListInspectionsUser.vue?777a7b06